import type { Breakpoint } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";


type BreakpointMode = "up" | "down" | "only" | "not";
export const useBreakpoint = (bp: Breakpoint | number, mode: BreakpointMode = "up"): boolean => {
	const theme = useTheme();

	return useMediaQuery(theme.breakpoints[mode](bp as Breakpoint));
};